// Create mouse events for individual cards
const createMouseEvents = element => {
  const card = element
  const anchor = card.querySelector('a')
  const href = anchor ? anchor.getAttribute('href') : null

  card.style.cursor = 'pointer'

  if (!href) return

  card.addEventListener('click', e => {
    e.preventDefault()

    if (e.ctrlKey || e.metaKey || anchor.getAttribute('target')) {
      window.open(href)
    } else {
      window.location = href
    }
  })
}

// Bind mouse events to cards
const bindMouseEvents = selector => {
  const elements = document.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach(element => {
      createMouseEvents(element)
    })
  }
}

bindMouseEvents('[data-card-component]')
